module.exports = "<p>\n  filter-products works!\n</p>\n"